import { gql } from "@apollo/client";

export const MUTATION_UPDATE_NOTIFICATION_CRON_CONFIG = gql`
  mutation UpdateNotificationCronConfig($cronIntervalHours: Float!) {
    updateNotificationCronConfig(cronIntervalHours: $cronIntervalHours) {
      id
      cronIntervalHours
    }
  }
`;

export const MUTATION_UPSERT_NOTIFICATION_RECIPIENTS = gql`
  mutation UpsertNotificationRecipients(
    $licenseId: String!
    $product: Product!
    $extraRecipients: String
  ) {
    upsertNotificationRecipients(
      licenseId: $licenseId
      product: $product
      extraRecipients: $extraRecipients
    ) {
      id
      licenseId
      product
      extraRecipients
    }
  }
`;
